/**
 * Dashboard-level constants and localStorage prefs helpers.
 * Extracted from Dashboard.jsx in V2.1.6 to keep the page file lean.
 */
export const TIER_RANK = { free: 0, pro: 1, elite: 2 };
export const FREE_SYMBOLS = new Set(["MNQ=F"]);
export const FREE_PERIODS = new Set(["1d", "2d", "5d", "7d"]);

export const PROFILE_LABELS = {
  "1m": "Micro-Scalp Imbalance", "2m": "Low Frame Delivery", "3m": "Minor Structural Range",
  "5m": "Intraday Confirmed Orderflow", "15m": "Tactical Session Liquidity", "30m": "Session Pivot",
  "1h": "HTF Trend Core", "4h": "Macro Dealing Range", "1D": "Institutional Narrative",
};

export function loadPref(key, fallback) {
  try { const raw = localStorage.getItem(key); return raw ? { ...fallback, ...JSON.parse(raw) } : fallback; }
  catch { return fallback; }
}

// One-time migration: AccountPage used to write legacy keys (liquidity/bos/mss) that the
// chart engine never reads (it reads sweeps/structure/ifvg). Map them across once so users
// who toggled them OFF in their account settings see the chart actually honor it.
export function migrateLegacyVisualKeys() {
  try {
    const raw = localStorage.getItem("ict.visual");
    if (!raw) return;
    const cur = JSON.parse(raw) || {};
    const hasLegacy = ("liquidity" in cur) || ("bos" in cur) || ("mss" in cur);
    if (!hasLegacy && ("ifvg" in cur)) return; // already migrated
    const next = { ...cur };
    if ("liquidity" in next) { next.sweeps = !!next.liquidity; delete next.liquidity; }
    if ("bos" in next || "mss" in next) {
      const bosV = "bos" in next ? !!next.bos : true;
      const mssV = "mss" in next ? !!next.mss : true;
      next.structure = bosV && mssV;
      delete next.bos; delete next.mss;
    }
    if (!("ifvg" in next)) next.ifvg = next.fvg !== false;
    localStorage.setItem("ict.visual", JSON.stringify(next));
  } catch {}
}
